import React from 'react';
import { Input } from "@/components/ui/input";

/**
 * SmartNumberInput
 * - Maneja correctamente el '0' inicial.
 * - Permite borrar todo el contenido (vuelve a '').
 * - No concatena números sobre 0 (01 -> 1).
 * - Hereda todos los props del Input estándar.
 */
const SmartNumberInput = ({ value, onChange, className, ...props }) => {

    const handleChange = (e) => {
        const val = e.target.value;

        // Si está vacío, pasar cadena vacía o null según preferencia
        if (val === '') {
            onChange('');
            return;
        }

        // Si es numérico válido
        const num = parseFloat(val);
        if (!isNaN(num)) {
            onChange(num);
        }
    };

    const handleFocus = (e) => {
        if (value === 0 || value === '0') {
            // No hacemos nada especial aquí si el value prop ya lo maneja como '',
            // pero por si acaso, forzamos el vaciado visual si fuera necesario.
            // En este caso, el componente está controlado, así que basta con que el value prop sea ''
        }
        if (props.onFocus) props.onFocus(e);
    };

    return (
        <Input
            type="number"
            value={(value === 0 || value === '0') ? '' : value}
            onChange={handleChange}
            onFocus={handleFocus}
            className={className}
            autoComplete="off"
            {...props}
        />
    );
};

export default SmartNumberInput;
